module.exports = __webpack_public_path__ + "img/pass_ok.36585c22.png";